import * as types from "../../../EarningsGroup/actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.ADD_EARNINGS_GROUP_PAGE_MAIN_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
